__webpack_require__.p = "https://assets-01.periodica.press/6f3461f-22069312210/";